var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounLove4726271(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.845,
    height: 34.724,
    viewBox: "0 0 37.845 34.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-love-4726271",
    d: "M81.569,23.09a11.546,11.546,0,0,0-8.185,19.718l14.7,14.663a1.183,1.183,0,0,0,1.668,0L104.46,42.808A11.484,11.484,0,0,0,88.92,25.914a11.53,11.53,0,0,0-7.351-2.824Zm0,2.353a9.2,9.2,0,0,1,6.517,2.7,1.183,1.183,0,0,0,1.668,0,9.2,9.2,0,1,1,13.035,12.991L88.921,54.965,75.053,41.131A9.193,9.193,0,0,1,81.57,25.443Z",
    transform: "translate(-70 -23.09)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLove4726271);
export default __webpack_public_path__ + "static/media/noun-love-4726271.5a80e24660422d92edcec045d0a3b510.svg";
export { ForwardRef as ReactComponent };